import script from "./iconfontSvg.vue?vue&type=script&lang=ts&setup=true"
export * from "./iconfontSvg.vue?vue&type=script&lang=ts&setup=true"

import "./iconfontSvg.vue?vue&type=style&index=0&id=257422dc&lang=less"

const __exports__ = script;

export default __exports__